import { useMutation } from 'react-query';

// Services
import { postGenerateOTP, postValidateOTP } from '..';

export function useGenerateOTP() {
  return useMutation({
    mutationKey: ['generateOTP'],
    mutationFn: postGenerateOTP,
  });
}

export function useValidateOTP() {
  return useMutation({
    mutationKey: ['validateOTP'],
    mutationFn: postValidateOTP,
  });
}
